// extracted by mini-css-extract-plugin
export var buttonsContainer = "CreateKeyValue-module--buttonsContainer--6ccab";
export var deleteButton = "CreateKeyValue-module--deleteButton--dda6e";
export var form = "CreateKeyValue-module--form--69e0c";
export var keyValue = "CreateKeyValue-module--keyValue--094c5";
export var table = "CreateKeyValue-module--table--4e9a8";
export var tableHeader = "CreateKeyValue-module--tableHeader--a9655";